export function createRequestSubmitData(formData) {
    let data = {
        job: formData.job,
        truck: formData.truck,
        notes: formData.notes,
        items: []
    }

    formData.equipment.forEach(item => {
        data.items.push({
            id: item.id,
            requestedQuantity: parseInt(item.requestQty)
        })
    })

    return data
}

// Optional: You can add more utility functions here if needed
export function extractErrorMessage(error) {
    if (!error) return 'Unknown error occurred';
    
    // Handle GraphQL errors
    if (error.graphQLErrors && error.graphQLErrors.length > 0) {
        return error.graphQLErrors[0].message || 'GraphQL error occurred';
    }
    
    // Handle network errors
    if (error.networkError) {
        return error.networkError.message || 'Network error occurred';
    }
    
    // Handle general errors
    return error.message || 'Unknown error occurred';
}
